export const bundleStatusToVariant = (status: string) => {
  switch (status.toUpperCase()) {
    case "ACTIVE":
      return "active";
    case "COMPLETED":
      return "completed";
    case "EXPIRED":
      return "expired";
    case "INACTIVE":
      return "inactive";
    case "FULLY_REFUNDED":
      return "fully-refunded";
    case "COMPLETED_WITH_PARTIAL_REFUND":
      return "completed-with-partial-refund";
    case "TRANSFERRED":
      return "transferred";
    case "CONVERTED":
      return "converted";
    default:
      return "active";
  }
};
